import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Toast } from 'vant';
import useDepartmentList from './hooks/useDepartmentList';
import emitter from '@/eventbus/index';
export default defineComponent({
  name: 'SelectStaff',
  components: {},
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var searchVal = ref('');
    var isre = ref(false);
    var checked = ref({
      id: 0
    });
    var tree_stack = ref([{
      name: '全部'
    }]);
    //搜索
    var confirmSearch = function confirmSearch(val) {
      tree_stack.value.push({
        name: '搜索结果'
      });
      isre.value = true;
      searchVal.value = val;
      init();
      getDepartmentInfoAsync({
        id: 0,
        user_name: searchVal.value
      });
    };
    var backTree = function backTree(item, index) {
      if (index === -1) {
        //点击了全部，从头开始请求数据
        init();
        getDepartmentListAsync();
        tree_stack.value.splice(1);
        isre.value = false;
        searchVal.value = '';
      } else if (index === -2) {
        tree_stack.value.splice(1);
      } else {
        if (tree_stack.value.length - index > 2) {
          tree_stack.value.forEach(function (item, i) {
            if (i > index) {
              tree_stack.value.splice(i);
            }
          });
        } else if (index !== tree_stack.value.length - 1) {
          tree_stack.value.splice(tree_stack.value.length - 1, 1);
        }
        // tree.value = item[children]
        init();
        getDepartmentInfoAsync({
          id: item.id,
          user_name: ''
        });
      }
    };
    var _useDepartmentList = useDepartmentList(),
      _useDepartmentList2 = _slicedToArray(_useDepartmentList, 4),
      firstLoad = _useDepartmentList2[0],
      list = _useDepartmentList2[1],
      getDepartmentListAsync = _useDepartmentList2[2],
      getDepartmentInfoAsync = _useDepartmentList2[3];
    onMounted(function () {
      getDepartmentListAsync();
    });
    var getChildren = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(item) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!item.user) {
                _context.next = 4;
                break;
              }
              checked.value = _objectSpread({}, item);
              _context.next = 8;
              break;
            case 4:
              tree_stack.value.push(_objectSpread({}, item));
              init();
              _context.next = 8;
              return getDepartmentInfoAsync({
                id: item.id,
                user_name: ''
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getChildren(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var init = function init() {
      //清空数组
      list.value = [];
      firstLoad.value = true;
    };
    var router = useRouter();
    var confirm = function confirm() {
      if (checked.value.id) {
        emitter.emit('select-staff', checked.value);
        setTimeout(function () {
          router.back();
        }, 500);
      } else {
        Toast('请选择员工');
      }
    };
    return {
      confirmSearch: confirmSearch,
      searchVal: searchVal,
      tree_stack: tree_stack,
      backTree: backTree,
      list: list,
      checked: checked,
      getChildren: getChildren,
      confirm: confirm,
      firstLoad: firstLoad
    };
  }
});